import { render, staticRenderFns } from "./AnamnesiBotoxEdit.vue?vue&type=template&id=3f1d5f18"
import script from "./AnamnesiBotoxEdit.vue?vue&type=script&lang=js"
export * from "./AnamnesiBotoxEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports